/* withheld.js — behaviour for the WITHHELD storefront sections. No dependencies. */
(function () {
  'use strict';
  if (window.WH_INIT) return;
  window.WH_INIT = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var EMAIL = /^\S+@\S+\.\S+$/;

  function money(cents, currency) {
    var cur = currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('[data-wh-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.hidden = true; }, 2200);
  }
  window.WH = { toast: toast, money: money };

  /* ---------- layers (drawers / overlays) ---------- */
  function openLayer(name) {
    closeLayers();
    var el = $('[data-wh-layer="' + name + '"]'); if (!el) return;
    el.hidden = false; document.documentElement.style.overflow = 'hidden';
    var f = $('[data-wh-autofocus]', el); if (f) setTimeout(function () { f.focus(); }, 30);
    if (name === 'cart') renderCart();
  }
  function closeLayers() {
    $$('[data-wh-layer]').forEach(function (l) { l.hidden = true; });
    document.documentElement.style.overflow = '';
    var m = $('[data-wh-layer="menu"]'); if (m) m.classList.remove('sub-open');
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-wh-open]'); if (o) { e.preventDefault(); openLayer(o.getAttribute('data-wh-open')); return; }
    if (e.target.closest('[data-wh-close]')) { e.preventDefault(); closeLayers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeLayers(); closeMega(); } });

  /* ---------- header: transparency + mega ---------- */
  var header = $('[data-wh-header]');
  function onScroll() {
    if (!header || !header.hasAttribute('data-transparent-ok')) return;
    header.classList.toggle('is-transparent', window.scrollY <= 30 && !header.classList.contains('mega-open'));
  }
  function closeMega() { if (!header) return; header.classList.remove('mega-open'); var b = $('[data-wh-mega-toggle]', header); if (b) b.setAttribute('aria-expanded', 'false'); onScroll(); }
  var megaOpenedAt = 0;
  function openMega() { if (!header) return; if (!header.classList.contains('mega-open')) megaOpenedAt = Date.now(); header.classList.add('mega-open'); header.classList.remove('is-transparent'); var b = $('[data-wh-mega-toggle]', header); if (b) b.setAttribute('aria-expanded', 'true'); }
  if (header) {
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    var mt = $('[data-wh-mega-toggle]', header);
    if (mt) {
      mt.addEventListener('mouseenter', openMega);
      /* a click right after the hover-open keeps it open; a later click closes it */
      mt.addEventListener('click', function () {
        if (header.classList.contains('mega-open') && Date.now() - megaOpenedAt > 500) closeMega(); else openMega();
      });
    }
    $$('[data-wh-mega-close]', header).forEach(function (n) { n.addEventListener('mouseenter', closeMega); });
    header.addEventListener('mouseleave', closeMega);
  }

  /* mobile menu sub panes */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-wh-sub]'); if (!s) return;
    var menu = $('[data-wh-layer="menu"]'); var id = s.getAttribute('data-wh-sub');
    $$('[data-wh-subgroup]', menu).forEach(function (g) { g.hidden = g.getAttribute('data-wh-subgroup') !== id; });
    var crumb = $('[data-wh-crumb]', menu); if (crumb) { crumb.hidden = false; $('[data-wh-crumb-label]', menu).textContent = s.getAttribute('data-label'); }
    menu.classList.add('sub-open');
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-wh-menu-back]')) return;
    var menu = $('[data-wh-layer="menu"]'); menu.classList.remove('sub-open');
    var crumb = $('[data-wh-crumb]', menu); if (crumb) crumb.hidden = true;
  });

  /* ---------- tabs (home carousel + cart recs) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-wh-tab]'); if (!t) return;
    var group = t.closest('[data-wh-tabs]'); var id = t.getAttribute('data-wh-tab');
    $$('[data-wh-tab]', group).forEach(function (b) { var on = b === t; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on); });
    $$('[data-wh-panel]', group).forEach(function (p) { p.hidden = p.getAttribute('data-wh-panel') !== id; });
  });

  /* ---------- carousel arrows ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-wh-scroll]'); if (!a) return;
    var scope = a.closest('[data-wh-carousel]'); if (!scope) return;
    var track = $$('[data-wh-track]', scope).filter(function (t) { return !t.hidden; })[0]; if (!track) return;
    track.scrollBy({ left: Number(a.getAttribute('data-wh-scroll')) * track.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ---------- cart ---------- */
  function setCount(n) { $$('[data-wh-cart-count]').forEach(function (c) { c.textContent = n; }); }
  function fetchCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function renderCart(cart) {
    var drawer = $('[data-wh-layer="cart"]'); if (!drawer) return Promise.resolve();
    var p = cart ? Promise.resolve(cart) : fetchCart();
    return p.then(function (c) {
      setCount(c.item_count);
      var lines = $('[data-wh-lines]', drawer), empty = $('[data-wh-cart-empty]', drawer), foot = $('[data-wh-cart-foot]', drawer);
      empty.hidden = c.item_count > 0; foot.hidden = c.item_count === 0; lines.hidden = c.item_count === 0;
      $('[data-wh-subtotal]', drawer).textContent = money(c.total_price, c.currency);
      lines.innerHTML = c.items.map(function (it) {
        var img = it.image ? '<img src="' + esc(it.image) + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240" alt="' + esc(it.product_title) + '" loading="lazy">' : '';
        return '<div class="wh-line" data-key="' + esc(it.key) + '">' +
          '<a class="wh-line__img" href="' + esc(it.url) + '">' + img + '</a>' +
          '<div class="wh-line__info"><div class="wh-line__top"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a><span>' + money(it.final_line_price, c.currency) + '</span></div>' +
          (it.variant_title ? '<span class="wh-line__variant">' + esc(it.variant_title) + '</span>' : '') +
          '<div class="wh-line__bottom"><div class="wh-qty"><button type="button" data-wh-qty="-1" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-wh-qty="1" aria-label="Increase">+</button></div>' +
          '<button type="button" class="wh-link-btn wh-underline" style="font-size:12px;color:#6b6a66" data-wh-remove>Remove</button></div></div></div>';
      }).join('');
    });
  }
  function changeLine(key, qty) {
    return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  document.addEventListener('click', function (e) {
    var line = e.target.closest('.wh-line'); if (!line) return;
    var q = e.target.closest('[data-wh-qty]');
    var cur = Number($('.wh-qty span', line).textContent);
    if (q) changeLine(line.getAttribute('data-key'), Math.max(0, cur + Number(q.getAttribute('data-wh-qty'))));
    if (e.target.closest('[data-wh-remove]')) changeLine(line.getAttribute('data-key'), 0);
  });
  function addToCart(id, qty) {
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag'); return j; }); })
      .then(function () { openLayer('cart'); })
      .catch(function (err) { toast(err.message); throw err; });
  }
  window.WH.addToCart = addToCart;

  /* ---------- wishlist ---------- */
  function wishes() { return store.get('wh-wishlist', []); }
  function syncWish() {
    var w = wishes();
    $$('[data-wh-wish-count]').forEach(function (c) { c.textContent = w.length; });
    $$('[data-wh-wish]').forEach(function (b) {
      var on = w.indexOf(b.getAttribute('data-wh-wish')) > -1;
      b.textContent = on ? (b.getAttribute('data-on') || 'Saved') : (b.getAttribute('data-off') || 'Save');
      b.setAttribute('aria-pressed', on);
    });
  }
  function toggleWish(handle, silent) {
    var w = wishes(); var i = w.indexOf(handle);
    if (i > -1) w.splice(i, 1); else w.unshift(handle);
    store.set('wh-wishlist', w); syncWish();
    if (!silent) toast(i > -1 ? 'Removed from saved' : 'Saved for later');
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wh-wish]'); if (!b) return;
    e.preventDefault(); e.stopPropagation(); toggleWish(b.getAttribute('data-wh-wish'));
  });

  /* ---------- notify me (sends to the store contact inbox) ---------- */
  function notify(email, product, option) {
    var fd = new FormData();
    fd.append('form_type', 'contact'); fd.append('utf8', '✓');
    fd.append('contact[email]', email);
    fd.append('contact[name]', 'Back in stock request');
    fd.append('contact[body]', 'Notify me when this is back: ' + product + (option ? ' — ' + option : ''));
    return fetch(root + 'contact', { method: 'POST', body: fd }).catch(function () {});
  }

  /* ---------- product card quick add ---------- */
  function cardData(card) {
    var s = $('script[data-wh-card-json]', card);
    if (!card._wh) { try { card._wh = JSON.parse(s.textContent); } catch (e) { card._wh = { variants: [] }; } }
    return card._wh;
  }
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-wh-card]'); if (!card) return;
    var d = cardData(card);
    if (e.target.closest('[data-wh-card-plus]')) { e.preventDefault(); card.classList.add('is-open'); return; }
    var sz = e.target.closest('[data-wh-card-size]');
    if (sz) {
      e.preventDefault();
      var v = d.variants.filter(function (x) { return String(x.id) === sz.getAttribute('data-id'); })[0];
      $$('[data-wh-card-size]', card).forEach(function (b) { b.classList.remove('is-sel'); });
      if (v && v.available) { sz.classList.add('is-sel'); card._sel = v.id; $('[data-wh-card-err]', card).hidden = true; }
      else { card._notify = sz.textContent.trim(); $('[data-wh-card-sizes]', card).hidden = true; var n = $('[data-wh-card-notify]', card); n.hidden = false; $('[data-wh-card-notify-size]', n).textContent = card._notify; }
      return;
    }
    if (e.target.closest('[data-wh-card-back]')) { e.preventDefault(); $('[data-wh-card-sizes]', card).hidden = false; $('[data-wh-card-notify]', card).hidden = true; return; }
    if (e.target.closest('[data-wh-card-notify-send]')) {
      e.preventDefault();
      var inp = $('[data-wh-card-email]', card);
      if (!EMAIL.test(inp.value)) { $('[data-wh-card-email-err]', card).hidden = false; return; }
      notify(inp.value, d.title, card._notify);
      $('[data-wh-card-notify]', card).hidden = true; $('[data-wh-card-done]', card).hidden = false; inp.value = '';
      return;
    }
    var add = e.target.closest('[data-wh-card-add]');
    if (add) {
      e.preventDefault();
      var id = d.single ? (d.variants.filter(function (x) { return x.available; })[0] || {}).id : card._sel;
      if (!id) { $('[data-wh-card-err]', card).hidden = false; return; }
      var label = add.textContent;
      addToCart(id).then(function () { add.textContent = 'Added'; setTimeout(function () { add.textContent = label; }, 1400); });
    }
  });
  document.addEventListener('mouseleave', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-wh-card]')) e.target.classList.remove('is-open');
  }, true);

  /* ---------- predictive search ---------- */
  var sTimer;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-wh-search-input]')) return;
    var q = e.target.value.trim(), panel = e.target.closest('[data-wh-layer]');
    var idle = $('[data-wh-search-idle]', panel), res = $('[data-wh-search-res]', panel), none = $('[data-wh-search-none]', panel);
    clearTimeout(sTimer);
    if (!q) { idle.hidden = false; res.hidden = true; none.hidden = true; return; }
    sTimer = setTimeout(function () {
      fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var r2 = (j.resources && j.resources.results) || {}; var ps = r2.products || [], cs = r2.collections || [];
          idle.hidden = true; res.hidden = !ps.length; none.hidden = !!ps.length;
          $('[data-wh-search-cols]', res).innerHTML = cs.slice(0, 3).map(function (c) { return '<a class="wh-pill" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('');
          $('[data-wh-search-rows]', res).innerHTML = ps.map(function (p) {
            return '<a class="wh-search__row" href="' + esc(p.url) + '"><span class="wh-search__thumb">' + (p.image ? '<img src="' + esc(p.image) + '&width=160" alt="" loading="lazy">' : '') + '</span>' +
              '<span style="display:flex;flex-direction:column;gap:3px"><span style="font-size:14px">' + esc(p.title) + '</span><span style="font-size:12px;color:#6b6a66">' + money(Math.round(Number(p.price) * 100)) + '</span></span></a>';
          }).join('');
          var all = $('[data-wh-search-all]', res); all.href = root + 'search?type=product&q=' + encodeURIComponent(q); all.textContent = 'View all results';
        }).catch(function () {});
    }, 180);
  });
  document.addEventListener('click', function (e) {
    var p = e.target.closest('[data-wh-search-term]'); if (!p) return;
    e.preventDefault(); var inp = $('[data-wh-search-input]'); inp.value = p.getAttribute('data-wh-search-term'); inp.dispatchEvent(new Event('input', { bubbles: true })); inp.focus();
  });

  /* ---------- newsletter preference ---------- */
  document.addEventListener('click', function (e) {
    var p = e.target.closest('[data-wh-pref]'); if (!p) return;
    var form = p.closest('form');
    $$('[data-wh-pref]', form).forEach(function (b) { b.classList.toggle('is-on', b === p); });
    $('[data-wh-pref-input]', form).value = 'newsletter,prefers-' + p.getAttribute('data-wh-pref').toLowerCase();
  });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-wh-news]')) {
      var em = $('input[type=email]', f), err = $('[data-wh-news-err]', f), c = $('[data-wh-consent]', f);
      if (!EMAIL.test(em.value)) { e.preventDefault(); err.textContent = 'Enter a valid email.'; err.hidden = false; return; }
      if (c && !c.checked) { e.preventDefault(); err.textContent = 'Tick the box to agree to emails.'; err.hidden = false; }
    }
    if (f.matches('[data-wh-validate]')) {
      var bad = $$('[required]', f).filter(function (i) { return !i.value.trim() || (i.type === 'email' && !EMAIL.test(i.value)); })[0];
      if (bad) { e.preventDefault(); var er = $('[data-wh-form-err]', f); er.textContent = bad.getAttribute('data-msg') || 'Please fill this in.'; er.hidden = false; bad.focus(); }
    }
  });

  /* ---------- collection: density, filters, load more ---------- */
  var grid = $('[data-wh-grid]');
  function setDensity(n, mob) {
    if (!grid) return;
    grid.style.setProperty(mob ? '--wh-cols-m' : '--wh-cols', n);
    $$('[data-wh-density]').forEach(function (b) { if (b.hasAttribute(mob ? 'data-mob' : 'data-desk')) b.classList.toggle('is-on', Number(b.getAttribute('data-wh-density')) === n); });
  }
  if (grid) {
    var dd = store.get('wh-density', { d: 4, m: 2 }); setDensity(dd.d, false); setDensity(dd.m, true);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wh-density]'); if (!b) return;
    var mob = b.hasAttribute('data-mob'), n = Number(b.getAttribute('data-wh-density'));
    var dd2 = store.get('wh-density', { d: 4, m: 2 }); dd2[mob ? 'm' : 'd'] = n; store.set('wh-density', dd2); setDensity(n, mob);
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-wh-sort]')) {
      var u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); location.href = u.toString();
    }
  });
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-wh-more]'); if (!m) return;
    e.preventDefault(); m.disabled = true; m.textContent = 'Loading…';
    fetch(m.getAttribute('data-next')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var g2 = $('[data-wh-grid]', doc), more2 = $('[data-wh-more-wrap]', doc);
      if (g2) $$(':scope > *', g2).forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
      var wrap = $('[data-wh-more-wrap]'); if (wrap && more2) wrap.replaceWith(document.importNode(more2, true)); else if (wrap) wrap.remove();
      syncWish();
    });
  });

  /* ---------- product page ---------- */
  var pdp = $('[data-wh-pdp]');
  if (pdp) {
    var P = JSON.parse($('script[data-wh-product-json]', pdp).textContent);
    var sel = P.selected.slice();
    var sizeIdx = P.sizeIndex;
    var form = $('[data-wh-pdp-form]', pdp), idInput = $('input[name="id"]', form);
    var addBtn = $('[data-wh-pdp-add]', pdp), notifyBox = $('[data-wh-pdp-notify]', pdp), doneBox = $('[data-wh-pdp-done]', pdp);
    var chosenSize = P.hasSizes ? (P.preselect ? sel[sizeIdx] : null) : null;
    var findV = function (opts) { return P.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0]; };
    function render() {
      $$('[data-wh-opt]', pdp).forEach(function (b) {
        var i = Number(b.getAttribute('data-wh-opt')); b.classList.toggle('is-on', b.getAttribute('data-value') === sel[i]);
      });
      $$('[data-wh-opt-name]', pdp).forEach(function (l) { l.textContent = sel[Number(l.getAttribute('data-wh-opt-name'))]; });
      if (P.hasSizes) {
        $$('[data-wh-pdp-size]', pdp).forEach(function (b) {
          var probe = sel.slice(); probe[sizeIdx] = b.getAttribute('data-value'); var v = findV(probe);
          b.classList.toggle('is-out', !v || !v.available); b.classList.toggle('is-sel', chosenSize === b.getAttribute('data-value'));
        });
      }
      var probe2 = sel.slice(); if (P.hasSizes && chosenSize) probe2[sizeIdx] = chosenSize;
      var v = (P.hasSizes && !chosenSize) ? null : findV(probe2);
      var shown = v || P.variants.filter(function (x) { return x.options.every(function (o, i) { return i === sizeIdx || o === sel[i]; }); })[0] || P.variants[0];
      $('[data-wh-pdp-price]', pdp).textContent = money(shown.price);
      var cmp = $('[data-wh-pdp-compare]', pdp);
      cmp.hidden = !(shown.compare_at_price > shown.price); cmp.textContent = shown.compare_at_price ? money(shown.compare_at_price) : '';
      var soldAll = !P.available;
      var sizeOut = P.hasSizes && chosenSize && (!v || !v.available);
      notifyBox.hidden = !sizeOut || !doneBox.hidden;
      addBtn.disabled = soldAll || sizeOut;
      addBtn.textContent = soldAll ? P.t.soldout : (sizeOut ? 'Size ' + chosenSize + ' is sold out' : P.t.add);
      if (v) { idInput.value = v.id; if (P.updateUrl) history.replaceState(null, '', '?variant=' + v.id); if (v.media && P.mediaJump) jumpMedia(v.media); }
    }
    function jumpMedia(mediaId) {
      var item = $('[data-media-id="' + mediaId + '"]', pdp); if (!item) return;
      var g = item.parentElement; if (window.innerWidth < 800) g.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
    }
    pdp.addEventListener('click', function (e) {
      var o = e.target.closest('[data-wh-opt]');
      if (o) { sel[Number(o.getAttribute('data-wh-opt'))] = o.getAttribute('data-value'); doneBox.hidden = true; render(); return; }
      var s = e.target.closest('[data-wh-pdp-size]');
      if (s) { chosenSize = s.getAttribute('data-value'); $('[data-wh-pdp-err]', pdp).hidden = true; doneBox.hidden = true; render(); return; }
      if (e.target.closest('[data-wh-pdp-add]')) {
        e.preventDefault();
        if (P.hasSizes && !chosenSize) { $('[data-wh-pdp-err]', pdp).hidden = false; return; }
        addToCart(idInput.value).catch(function () {});
        return;
      }
      if (e.target.closest('[data-wh-pdp-notify-send]')) {
        var inp = $('[data-wh-pdp-email]', pdp);
        if (!EMAIL.test(inp.value)) { $('[data-wh-pdp-email-err]', pdp).hidden = false; return; }
        notify(inp.value, P.title, sel.map(function (x, i) { return i === sizeIdx ? chosenSize : x; }).join(' / '));
        inp.value = ''; doneBox.hidden = false; notifyBox.hidden = true;
      }
    });
    render();
    /* gallery dots */
    var gal = $('[data-wh-gallery]', pdp), dots = $$('[data-wh-dot]', pdp);
    if (gal && dots.length) gal.addEventListener('scroll', function () {
      var i = Math.round(gal.scrollLeft / gal.clientWidth); dots.forEach(function (d, j) { d.classList.toggle('is-on', i === j); });
    }, { passive: true });
    /* recently viewed */
    var rec = store.get('wh-recent', []).filter(function (h) { return h !== P.handle; });
    store.set('wh-recent', [P.handle].concat(rec).slice(0, 8));
    /* wishlist prompt */
    var wp = $('[data-wh-wishprompt]');
    if (wp && !sessionStorage.getItem('wh-wp') && wishes().indexOf(P.handle) === -1) {
      setTimeout(function () { if (wishes().indexOf(P.handle) === -1) { wp.hidden = false; sessionStorage.setItem('wh-wp', '1'); } }, Number(wp.getAttribute('data-delay') || 5000));
      wp.addEventListener('click', function (e) {
        if (e.target.closest('[data-wh-wp-yes]')) { if (wishes().indexOf(P.handle) === -1) toggleWish(P.handle); wp.hidden = true; }
        if (e.target.closest('[data-wh-wp-no]')) wp.hidden = true;
      });
    }
  }

  /* ---------- server-rendered card lists from handles (recent / saved) ---------- */
  function renderHandles(el, handles) {
    if (!handles.length) return Promise.resolve(0);
    return Promise.all(handles.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '?view=wh-card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (list) {
      var html = list.filter(Boolean).join(''); el.innerHTML = html; syncWish();
      return list.filter(Boolean).length;
    });
  }
  $$('[data-wh-recent]').forEach(function (sec) {
    var cur = sec.getAttribute('data-current');
    var hs = store.get('wh-recent', []).filter(function (h) { return h !== cur; }).slice(0, Number(sec.getAttribute('data-limit') || 4));
    renderHandles($('[data-wh-recent-grid]', sec), hs).then(function (n) { sec.hidden = !n; });
  });
  $$('[data-wh-saved]').forEach(function (sec) {
    renderHandles($('[data-wh-saved-grid]', sec), wishes()).then(function (n) {
      $('[data-wh-saved-has]', sec).hidden = !n; $('[data-wh-saved-empty]', sec).hidden = !!n;
    });
  });

  /* ---------- market popup ---------- */
  var mk = $('[data-wh-market]');
  if (mk && !store.get('wh-market', false) && !window.Shopify?.designMode) {
    setTimeout(function () { mk.hidden = false; }, 1500);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wh-market-dismiss]')) { store.set('wh-market', true); var m = $('[data-wh-market]'); if (m) m.hidden = true; }
    if (e.target.closest('[data-wh-market-open]')) { e.preventDefault(); var m2 = $('[data-wh-market]'); if (m2) m2.hidden = false; }
  });
  document.addEventListener('submit', function (e) { if (e.target.closest('[data-wh-market]')) store.set('wh-market', true); });

  /* ---------- boot ---------- */
  syncWish();
  fetchCart().then(function (c) { setCount(c.item_count); }).catch(function () {});
  if (/[?&]wh-cart=1/.test(location.search)) openLayer('cart');
  document.addEventListener('shopify:section:load', function () { syncWish(); });
})();
